const filenameCreator = (image: any, size: string = '2000x0'): string =>
  image?.filename?.includes('.svg') ? image?.filename : `${image?.filename}/m/${size}`;

export { filenameCreator };
